import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("authToken"));
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  const isAuthenticated = !!token;

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);

        setCurrentUser({
          id: decoded.id,
          email: decoded.email,
          role: decoded.role,
          permissoes: decoded.permissoes || [],
          isAdmin: decoded.permissoes?.includes("admin") || decoded.role === "admin",
        });
      } catch (err) {
        console.error("Erro ao decodificar token:", err);
        setCurrentUser(null);
      }
    } else {
      setCurrentUser(null);
    }
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem("authToken", newToken);
    setToken(newToken);
    navigate("/dashboard");
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    setToken(null);
    setCurrentUser(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{ token, currentUser, isAuthenticated, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
